<template>
  <div class="box">
    <div class="bg">
      <img class="bg-img" src="@/assets/images/bg.png" alt="" />
    </div>
    <img class="logo-img" src="@/assets/images/logo.png" alt="" />
    <div class="login-box">
      <div class="title">验证登录</div>
      <van-field v-model="idcard" label="身份证号" clearable label-width="70px" left-icon="contact" />
      <div class="confirm">
        <van-button class="confirm-btn" color="#E99D42" @click="login" :disabled="loading">
          <van-loading size="24px" color="#ffffff" v-if="loading">手机号登录中...</van-loading>
          <div v-else>登录</div>
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
// import { getInfoByIdcard, loginByIdcard } from '@/service/insurance'
import { loginByIdcard, loginByPhone } from '@/service/insurance'
export default {
  props: {},
  data() {
    return {
      loading: false,
      idcard: '',
      token: ''
    }
  },
  mounted() {
    this.loading = true
    // 获取url中的token给后端去校验是否是浙农服用户
    if (this.$route.query.token) {
      this.token = this.$route.query.token
      sessionStorage.setItem('aesToken', this.token)
    } else {
      this.token = sessionStorage.getItem('aesToken')
    }
    let data = {
      aesToken: this.token,
      grantType: 'phoneLogin',
      clientId: '428a8310cd442757ae699df5d894f051'
    }
    loginByPhone(data)
      .then((res) => {
        console.log(res)
        sessionStorage.setItem('Authorization', 'Bearer ' + res.data.access_token)
        this.loading = false
        setTimeout(() => {
          this.$router.replace('/insurance')
        }, 100)
      })
      .catch(() => {
        this.$toast.fail('手机号登录失败，请使用身份证登录')
        this.loading = false
      })
  },
  methods: {
    login() {
      // 验证idcard是否合规
      if (this.checkPsidno(this.idcard)) {
        // 验证idcard是否合规
        let data = {
          userIdCard: this.idcard,
          grantType: 'idCardLogin',
          clientId: '428a8310cd442757ae699df5d894f051'
        }
        loginByIdcard(data)
          .then((res) => {
            sessionStorage.setItem('idcard', this.idcard)
            sessionStorage.setItem('Authorization', 'Bearer ' + res.data.access_token)
            // 通过身份证获取保单信息获取用户信息判断是否完成申报
            // getInfoByIdcard(this.idcard).then((res) => {
            //   console.log(res.data)
            //   if (res.data.isCompleted == 1) {
            //     this.$toast.fail('该账号已完成申报！')
            //     return false
            //   } else {
            this.$toast.success('登陆成功')
            setTimeout(() => {
              this.$router.push('/insurance')
            }, 2000)
            //   }
            // })
          })
          .catch((err) => {
            this.$toast.fail(err || err.msg)
          })
      }
    },
    checkPsidno(value) {
      const psidno = String(value)
      // 1.校验身份证号格式和长度
      const regPsidno = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[X])$)$/
      if (!regPsidno.test(psidno)) {
        this.$toast.fail('身份证不合规，请重新输入')
        return false
      }
      // 2.校验前两位的省份编码是否正确
      const province = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江 ',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北 ',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏 ',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外'
      }
      if (!province[Number(psidno.slice(0, 2))]) {
        return false
      }
      // 3.校验出生日期
      if (psidno.length === 15) {
        // 15位号码 省（2位）市（2位）县（2位）年（2位）月（2位）日（2位）校验码（3位）
        const reg = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/)
        const arrSplit = psidno.match(reg)
        // 15位号码在年份前补 19 或 20
        const year = Number(arrSplit[2].charAt(0)) > 0 ? '19' + arrSplit[2] : '20' + arrSplit[2]
        const month = arrSplit[3]
        const day = arrSplit[4]
        if (!validateBirthday(year, month, day)) {
          this.$toast.fail('身份证不合规，请重新输入')
          return false
        }
      } else if (psidno.length === 18) {
        // 18位号码 省（2位）市（2位）县（2位）年（4位）月（2位）日（2位）校验码（4位）
        const reg = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/)
        const arrSplit = psidno.match(reg)
        const year = arrSplit[2]
        const month = arrSplit[3]
        const day = arrSplit[4]
        if (!validateBirthday(year, month, day)) {
          this.$toast.fail('身份证不合规，请重新输入')
          return false
        }
      } else {
        return false
      }
      // 校验出生日期是否合理
      function validateBirthday(year, month, day) {
        year = Number(year) // 年
        month = Number(month) // 月
        day = Number(day) // 日
        const nowTime = new Date().getTime() // 当前时间戳
        const birthTime = new Date(`${year}-${month}-${day}`).getTime() // 获取出生日期的时间戳
        if (birthTime > nowTime) {
          this.$toast.fail('身份证不合规，请重新输入')
          return false
        }
        // 一般人活不到150岁吧
        const nowYear = new Date().getFullYear()
        if (nowYear - year > 150) {
          this.$toast.fail('身份证不合规，请重新输入')
          return false
        }
        // 不能是13月出生的吧
        if (month < 1 || month > 12) {
          return false
        }
        // 不能是2月30号、4月31号、5月32号出生的吧
        const date = new Date(year, month, 0) // 获取当月的最后一天
        if (day < 1 || day > date.getDate()) {
          this.$toast.fail('身份证不合规，请重新输入')
          return false
        }
        return true
      }
      // 4.18位号码校验生成的校验码
      if (psidno.length === 18) {
        const Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2] // 加权因子
        const parity = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'] // 校验码
        let sum = 0
        for (let i = 0; i < 17; i++) {
          sum += Number(psidno.charAt(i)) * Wi[i]
        }
        if (parity[sum % 11] !== psidno[17]) {
          this.$toast.fail('身份证不合规，请重新输入')
          return false
        }
      }
      return true
    }
  }
}
</script>

<style lang="stylus" scoped>
body{
  width: 100%
  .box{
    height: 100vh
    overflow-y: scroll
    .bg{
      z-index: -1
      position: absolute
      height: 100%
      width: 100%
      .bg-img{
        width: 100%
        height: 100%
      }
    }
    .logo-img{
      margin: 20px
      width: 300px
    }
    .login-box{
      background: rgba(255,255,255,0.6)
      width: 650px
      height: 500px
      border-radius: 20px
      margin: 330px auto 30px auto
      padding: 30px
      .title {
        font-size: 52px
        font-weight: bold
        text-align: center
        margin: 0 auto 100px auto
      }
      .confirm{
        margin: 30px auto
        text-align: center
        .confirm-btn{
          border-radius: 20px
          width: 580px
        }
      }
    }
  }
}
</style>
